import React, { useContext } from 'react';
import { dayjs } from 'helpers/dayjs';
import { KeyIcon, QrTinyIcon } from 'assets/icons';
import { AppContext } from 'context/app-context';
import { ReactComponent as Logo } from 'assets/images/logo.svg';
import {
  classnames,
  isOwner,
  isRestrictedVault,
  showTextEllipsis,
} from 'helpers/utils';
import { isEmpty } from 'lodash';
import { Button, ButtonStyle } from 'common/button';
import { VaultStorage } from '../vault-storage';
import styles from './vault-card-mobile.module.scss';

type VaultCardMobileProps = {
  vault: VaultType;
  showVaultStatusLabel: Function;
  notifyClickCard: (id: number, keyEvent?: boolean) => () => void;
  notifyClickQrIcon: (id: number) => void;
};

const VaultCardMobile: React.FC<VaultCardMobileProps> = ({
  vault,
  showVaultStatusLabel,
  notifyClickCard,
  notifyClickQrIcon,
}) => {
  const { state } = useContext(AppContext);
  const { user } = state.data;

  const showCard = () => (
    <div
      role="button"
      tabIndex={0}
      className={styles.cardMobile}
      onClick={notifyClickCard(vault.id)}
      onKeyDown={notifyClickCard(vault.id, true)}
    >
      <div
        className={classnames(styles.pictureBox, {
          [styles.greyImage]: isRestrictedVault(vault),
        })}
      >
        {showVaultStatusLabel(vault, styles.statusLabelPosition)}

        {vault.coverThumbnailUrl ? (
          <img
            src={vault.coverThumbnailUrl}
            className={styles.picture}
            alt="logo"
          />
        ) : (
          <div className={styles.defaultPicture}>
            <Logo className={styles.logo} />
          </div>
        )}
      </div>

      <div className={styles.info}>
        <div className={styles.nameAndOwner}>
          <div className="text__body__semi__bold__small__gray800">
            {showTextEllipsis(vault.title, 69)}
          </div>
          <div className={styles.cardIcons}>
            {!isEmpty(vault.qrCodes) && (
              <Button
                className={styles.qrIconButton}
                buttonStyle={ButtonStyle.PrimaryGhost}
                onClick={(event) => {
                  event.stopPropagation();
                  notifyClickQrIcon(vault.id);
                }}
              >
                <QrTinyIcon className={styles.qrIcon} />
              </Button>
            )}
            {isOwner(user, vault) && <KeyIcon className={styles.ownerIcon} />}
          </div>
        </div>
        <div className={styles.horizontalLine} />
        <div
          className={classnames(
            styles.lastUpdate,
            'text__body__regular__small__gray700',
          )}
        >
          {`Last updated: ${dayjs(vault.lastUpdate).fromNow()}`}
        </div>
        <VaultStorage vault={vault} />
        {vault.owner.companyName && !isOwner(user, vault) && (
          <div className={classnames('text__body__regular__small__gray500')}>
            {`Powered by: ${showTextEllipsis(vault.owner.companyName, 30)}`}
          </div>
        )}
      </div>
    </div>
  );

  return showCard();
};

export { VaultCardMobile };
